import { App, PreviewImage } from '@plone/volto/components';

export const components = {
  PreviewImage: { component: PreviewImage },
  App: { component: App },
};
